export default __webpack_public_path__ + "static/media/pexels-engin-akyurt-1435752.1c9c6f92.jpg";